import { removeChatFromSpam, setChatOperationPending } from './actions';
import {
  TChatsRemoveFromSpamDesktopResponse,
  fetchChatsRemoveFromSpamDesktop,
} from '../../repositories/chats/v1/chats/remove-from-spam-desktop';
import { showAlert } from '../../slices/alertSlice';
import { TThunkAction } from '../../types/redux/thunk';
import { ERoute } from '../../types/route';
import { changeRoute } from '../route';

/**
 * Пытаемся восстановить чат из спама
 */
export const removeFromSpam =
  (chatId: string): TThunkAction<Promise<void>> =>
  async (dispatch, getState, { httpApi, logger }) => {
    dispatch(setChatOperationPending(true));

    try {
      const { statusCode, response }: TChatsRemoveFromSpamDesktopResponse = await fetchChatsRemoveFromSpamDesktop({
        httpApi,
        parameters: { chatId },
        config: { requestConfig: { withCredentials: true } },
      });

      dispatch(setChatOperationPending(false));

      // @ts-expect-error модель не совпадает с кодом сервера
      if (statusCode === 200 || statusCode === 204) {
        dispatch(removeChatFromSpam(chatId));

        /**
         * При удачном восстановлении чата из спама, переводим пользователя на страницу активных чатов
         */
        dispatch(changeRoute({ route: ERoute.Messages }));
        dispatch(showAlert({ message: 'Чат разблокирован' }));

        return;
      }

      /**
       * При неудачной попытке восстановить чат из спама, показываем алерт с ошибкой
       */
      dispatch(showAlert({ message: response.message || 'Возникла ошибка при попытке восстановить чат' }));
    } catch (error) {
      logger.error(error, {
        chatId,
        domain: 'frontend-chats.actions.removeFromSpam',
        description: 'Ошибка при попытке восстановить из спама',
      });

      dispatch(setChatOperationPending(false));
      dispatch(showAlert({}));
    }
  };
